import axiosInstance from "@/services/axiosinstance";

export const actions = {
  getGroup({ commit }) {
    commit("GROUPS");
  },

  /** Restore a saved estimate once, at app start. */
  restoreEstimate({ commit }) {
    try {
      const storedServices = localStorage.getItem("services");
      if (storedServices) {
        commit("SET_SERVICES", JSON.parse(storedServices));
      }
      const storedGroups = localStorage.getItem("groups");
      if (storedGroups) {
        commit("SET_GROUPS", JSON.parse(storedGroups));
      }
    } catch (error) {
      console.warn("Could not restore the saved estimate:", error);
    }
  },

  async updateExchangeRates({ commit }) {
    try {
      const response = await axiosInstance.get("/rates");
      if (response.status === 200) {
        const { rates, lastUpdated } = response.data;

        console.info(`Exchange rates last updated: ${lastUpdated}`);
        const exchangeRates = {
          EUR: 1,
          ...rates,
        };

        commit("updateExchangeRates", exchangeRates);
      }
    } catch (error) {
      console.log("Error fetching exchange rates:", error);
    }
  },
};
